const POLICY_TEXT = {
  showcase:
    'Мы оставляем за собой право акцептовать любое из поступивших предложений либо не акцептовать ни одно из них. Торговые процедуры являются конкурентными процедурами, не регулируются 223-ФЗ, 44-ФЗ, порядок отказа от проведения торгов устанавливается в извещении о проведении закупки товаров, работ, услуг.',
}

export { POLICY_TEXT }
